<template>
	<div :class="{'progress-block-vertical': layout == 'vertical', 'progress-block-horizontal': layout == 'horizontal'}" class="progress-block">
		<div class="col-1">
			<div class="progress">
				<div class="progress-bar" role="progressbar" :style="{ width: share + '%'}" />
			</div>
		</div>
		<div class="col-2">
			{{ label }}
		</div>
	</div>
</template>

<script setup>
defineProps({
	share: {
		type: Number,
		required: true,
	},

	label: {
		type: String,
		required: true,
	},

	layout: {
		type: String,
		default: "horizontal"
	}
})
</script>

<style>
	.progress-block{

	}

	.progress-block-horizontal{
		display: table;
		width: 100%;
		
		.col-1, .col-2{
			display: table-cell;
		}

		.col-2{
			width: 1%;
		}
	}

	.progress-block-vertical{
		.col-1, .col-2{
			text-align: center;
		}
	}
</style>